import styled from 'styled-components';

import {LoadingButton} from '@edna/components';
import {mixins} from '@edna/components/styles';

export const CaptchaImg = styled.div`
  ${mixins.flexAlign('center')}
  ${mixins.wh('160px', '70px')}
`;

export const CaptchaImageWithIcon = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
`;

export const RefreshButton = styled(LoadingButton)`
  box-shadow: none;
  &:active {
    background-color: transparent;
  }
`;
